export function formatMoney(amount, { currency = "PEN", locale = "es-PE" } = {}) {
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);
  } catch {
    return Number(amount || 0).toFixed(2);
  }
}